export enum DeliveryOption {
    DELIVERY = "DELIVERY",
    PICKUP = "PICKUP",
}
